import { createFileRoute } from '@tanstack/react-router';

import { LegalHolidayBrowse } from '@/module/LegalHoliday/LegalHolidayBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/legal-holiday/_legal-holiday/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LegalHolidayBrowse />;
}
